import { Fragment } from 'react';
import { getRandomUid } from 'utilities/uuid.service';

function PasswordInputField({ labelProps = {}, inputProps = {}, fieldErrors = {} }) {
  const { label = ' PasswordField label', ...rest } = labelProps;
  const { id, className = '', ...props } = inputProps;

  const textFieldID = id ?? getRandomUid();

  let selectBoxClasses = '';
  const { errorMessage = '' } = fieldErrors;

  if (errorMessage) {
    selectBoxClasses = 'border border-danger';
  }

  return (
    <Fragment>
      <label htmlFor={textFieldID} {...rest}>
        {label}
      </label>
      <input
        type="password"
        placeholder="placeholder"
        id={textFieldID}
        className={`${className} ${selectBoxClasses}`}
        {...props}
      />
    </Fragment>
  );
}

export default PasswordInputField;
